import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import DOMPurify from 'dompurify';
import startCase from 'lodash/startCase';
import privacyPolicyContent from '../../components/templates/privacyPolicyTemplate';

const PrivacyPolicyOpen = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const categorySlug = params.get('category');

  const appName = useMemo(() => {
    if (!categorySlug) return 'ReadRivals';
    const prettyCategory = startCase(categorySlug.trim().toLowerCase());
    return `ReadRivals ${prettyCategory}`;
  }, [categorySlug]);

  const safeAppName = useMemo(() => {
    const div = document.createElement('div');
    div.textContent = appName;
    return div.innerHTML;
  }, [appName]);

  const processedContent = useMemo(() => {
    const htmlWithBrand = privacyPolicyContent.replace(
      /\bReadRivals('s)?\b/gi,
      (_, possessive) => (possessive ? `${safeAppName}'s` : safeAppName)
    );
    return DOMPurify.sanitize(htmlWithBrand);
  }, [safeAppName]);

  useEffect(() => {
    document.title = `${safeAppName} Privacy Policy`;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = `${safeAppName} Privacy Policy`;
  }, [safeAppName]);

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <div dangerouslySetInnerHTML={{ __html: processedContent }} />
    </div>
  );
};

export default PrivacyPolicyOpen;